import { render, staticRenderFns } from "./SwitchDiscount.vue?vue&type=template&id=afba04fc&scoped=true"
import script from "./SwitchDiscount.vue?vue&type=script&lang=js"
export * from "./SwitchDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afba04fc",
  null
  
)

export default component.exports